import { Component, OnInit } from '@angular/core';
import { CustomerService } from '../../../../services/customer.service';
import { EditMvPole } from 'shared-lib';
import { Location } from '@angular/common';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { BuildingType, ClientType, Customer, CustomerAdd, CustomerEdit, CustomerType, InstallationAndPowerSource, ServiceType, SltStatus, TypeOfConnection } from '../../../../models/customer.model';
import { BillingType, getInitMeter, MeterCondition, MeterStatus, MeterType } from '../../../../models/meter.model';
import { HistoryOutput } from '../../../../models/history.model';
import { DtCustomerCreate, DtDto, getInitDtDto } from '../../../../models/dt.model';
import { Area } from '../../../../models/area.model';
import { RegionService } from 'shared-lib';
import { Region } from 'shared-lib';
import { AreaService } from 'shared-lib';
import { Feeder, FeederType } from '../../../../models/feeder.model';
import { Feeder11Service } from 'shared-lib';
import { Feeder33Service } from 'shared-lib';
import { TariffService } from '../../../../services/tariff.service';
import { Tariff } from '../../../../models/tariff.model';
import { OptionObj } from 'shared-lib';
import { DtService } from '../../../../services/dt.service';
import { MeterService } from '../../../../services/meter.service';
import { ValidationService } from '../../../../services/validation.seervice';
import { slideToggle } from '../../../../helpers/slidetoggle';
import { UtilitySharedService } from '../../../../shared/_services/utility-shared.service';

@Component({
  selector: 'app-add-new-customer-account',
  templateUrl: './add-new-customer-account.component.html',
  styleUrl: './add-new-customer-account.component.scss',
  animations: [slideToggle],
  standalone: false
})
export class AddNewCustomerAccountComponent implements OnInit {

  editMode: boolean = false;

  informationCardExpanded: boolean = false;
  tariffFeederDtCardExpanded: boolean = false;
  meterCardExpanded: boolean = false;
  statusCardExpanded: boolean = false;
  utilityId: number = 0;
  selectedRegionId: number = 0;
  selectedFeederType: number | null = null;
  selectedFeederNumber: string = '';
  selectedDtNumber: string;
  selectedSltStatusKey: number | null = null;

  regions: Region[] = [];
  allAreas: Area[] = [];
  areas: Area[] = [];
  feeders: Feeder[] = [];
  tariffs: Tariff[] = [];
  sltOptions: OptionObj[] = [];
  selectedSltStatus: OptionObj = {
    key: 0,
    value: '',
  };
  dts: DtCustomerCreate[] = [];
  meterTypes: MeterType[] = [];

  selectedMvPole: EditMvPole;
  customerId: number = 0;
  customerEdit: CustomerEdit = new CustomerEdit();
  customer: CustomerAdd = {
    id: 0,
    dataQualityId: 0,
    slrn: '',
    name: '',
    accountNumber: '',
    address: '',
    email: undefined,
    phoneNumber: undefined,
    tariffName: '',
    serviceType: ServiceType.NotSelected,
    buildingType: BuildingType.NotSelected,
    customerType: null,
    typeOfConnection: TypeOfConnection.NotSelected,
    clientType: ClientType.NotSelected,
    regionId: 0,
    areaId: 0,
    tariffId: 0,
    dtId: 0,
    isNew: false,
    billingType: BillingType.NotSelected,
    meter: getInitMeter(),
    dt: getInitDtDto(),
    isNewConnection: false,
    history: new HistoryOutput(),
    spn: '',
    blockNumber: null,
    geoCode: null,
    activityCode: '',
    currentPlotCode: '',
    ghanaPostGPS: '',
    sltStatus: undefined,
    area: new Area(),
    buildingId: 0,
    surveyStatus: '',
    utilityId: 0,
    isChecked: false,
    isAudited: false,
    isReviewed: false
  };

  meterStatusOptions = [
    { name: 'CUSTOMER_DETAILS.UNMETERED', value: MeterStatus.Unmetered },
    { name: 'CUSTOMER_DETAILS.METERED', value: MeterStatus.Metered },
  ];

  useOfPremisesOptions = [
    { name: 'COMMON.BUILDING_TYPE.RESIDENTIAL', value: BuildingType.Residential },
    { name: 'COMMON.BUILDING_TYPE.COMMERCIAL', value: BuildingType.Commercial },
    { name: 'COMMON.BUILDING_TYPE.INDUSTRIAL', value: BuildingType.Industrial },
    { name: 'COMMON.BUILDING_TYPE.MIXED', value: BuildingType.Mixed },
  ];

  serviceTypeOptions = [
    { name: 'COMMON.SERVICE_TYPE.LARGE', value: ServiceType.Large },
    { name: 'COMMON.SERVICE_TYPE.SMALL', value: ServiceType.Small },
    { name: 'COMMON.SERVICE_TYPE.PREPAID', value: ServiceType.Prepaid },
    { name: 'COMMON.SERVICE_TYPE.AMR', value: ServiceType.AMR },
  ];

  clientTypeOptions = [
    { name: 'COMMON.CLIENT_TYPE_OPTIONS.COMPANY', value: ClientType.Company },
    {
      name: 'COMMON.CLIENT_TYPE_OPTIONS.EMBASSY_FOREIGN_INSTITUTION',
      value: ClientType.EmbassyForeignInstitution,
    },
    { name: 'COMMON.CLIENT_TYPE_OPTIONS.INDIVIDUAL', value: ClientType.Individual },
    { name: 'COMMON.CLIENT_TYPE_OPTIONS.GOVERNMENT', value: ClientType.Government },
    { name: 'COMMON.CLIENT_TYPE_OPTIONS.ASSEMBLY', value: ClientType.Assembly },
  ];

  ngOnInit(): void {
    const id = this.route.snapshot.paramMap.get('id');
    
    this.selectedMvPole = new EditMvPole();
    this.getRegions();
    this.getTariffs();
    this.getSltStatuses();
    this.getMeterTypes();
    if (id != null && id != undefined) {
      this.getCustomer(id);
      this.editMode = true;
    }
  }
  
  constructor(
    private customerService: CustomerService,
    private location: Location,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private router: Router,
    private regionService: RegionService,
    private areaService: AreaService,
    private f11Service: Feeder11Service,
    private f33Service: Feeder33Service,
    private tariffService: TariffService,
    private dtService: DtService,
    private meterService: MeterService,
    private validationService: ValidationService,
    private sharedService: UtilitySharedService
  ) {
    this.utilityId = Number(this.sharedService.getUtilityId());
  }

  

  onDtChange() {
    const selectedDt = this.dts.find(dt => dt.externalId === this.customer.dtId);
    if (selectedDt) {
      const existingFeeder = { ...this.customer.dt.feeder };
      this.customer.dt = new DtDto(selectedDt);
      this.customer.dt.id = selectedDt.externalId || 0;
      this.customer.dt.number = selectedDt.number || '';
      this.customer.dt.feeder = existingFeeder;
      this.selectedDtNumber = selectedDt.number || '';
    } else {
      this.selectedDtNumber = '';
      this.customer.dt = new DtDto();
      this.customer.dt.feeder = this.customer.dt.feeder || new Feeder();
    }
  }

  private getCustomer(customerId: any) {
      this.customerService.get(customerId).subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK') {
            this.customerEdit = new CustomerEdit(responseData.data);
            this.customerEdit.feederId = this.customerEdit.dt?.feeder?.id;
            this.customerEdit.dtId = this.customerEdit.dt ? this.customerEdit.dt.id : 0;
            this.customerEdit.meterTypeId = this.customerEdit.meter?.meterType
              ? this.customerEdit.meter?.meterType?.id
              : 0;
            this.customerEdit.meterNo = this.customerEdit.meter
              ? this.customerEdit.meter.number
              : '';
            this.customerEdit.closestLandmark =
              this.customerEdit.building?.closestLandmark;
            this.customerEdit.spn = this.customerEdit.contractNumber;
            this.selectedSltStatus.key = this.customerEdit.sltStatus?.id;
            this.selectedSltStatus.value = this.customerEdit.sltStatus?.value;
            if (this.editMode)
              this.mapCustomers();
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => {
          this.toastr.error('Error occured');
        },
      });
    }

    private mapServiceType(text : string) {
      switch (text) {
        case 'Large':
          this.customer.serviceType = ServiceType.Large;
          break;
          case 'Small':
          this.customer.serviceType = ServiceType.Small;
          break;
          case 'Prepaid':
          this.customer.serviceType = ServiceType.Prepaid;
          break;
          case 'AMR':
          this.customer.serviceType = ServiceType.AMR;
          break;
          default:
          this.customer.serviceType = ServiceType.NotSelected;
          break;
      }
    }

    private mapBuildingType(text: string) {
      switch (text) {
        case 'Residential': 
          this.customer.buildingType = BuildingType.Residential;
          break;
        case 'Commercial':
          this.customer.buildingType = BuildingType.Commercial;
          break;
        case 'Industrial':
          this.customer.buildingType = BuildingType.Industrial;
          break;
        case 'Mixed':
          this.customer.buildingType = BuildingType.Mixed;
          break;
        case 'Religious House':
          this.customer.buildingType = BuildingType.ReligiousHouse;
          break;
        default:
          this.customer.buildingType = BuildingType.NotSelected    
          break;    
      }
    }

    private mapCustomerType(text : string) {
      switch (text) {
        case 'Prepaid':
          this.customer.customerType = CustomerType.Prepaid;
          break;
        case 'Postpaid':
          this.customer.customerType = CustomerType.Postpaid;
          break;
        default: 
          this.customer.customerType = null;
          break;
      }
    }

    private mapTypeOfConnection(text: string) {
      switch (text) {
        case 'ThreePhase':
          this.customer.typeOfConnection = TypeOfConnection.ThreePhase;
          break;
        case 'SinglePhase':
          this.customer.typeOfConnection = TypeOfConnection.SinglePhase;
          break;
        default:
          this.customer.typeOfConnection = TypeOfConnection.NotSelected;
          break;
      }
    }

    private mapClientType(text: string) {
      switch (text) {
        case 'Company':
          this.customer.clientType = ClientType.Company;
          break;
        case 'EmbassyForeignInstitution':
          this.customer.clientType = ClientType.EmbassyForeignInstitution;
          break;
        case 'Individual':
          this.customer.clientType = ClientType.Individual;
          break;
        case 'Government':
          this.customer.clientType = ClientType.Government;
          break;
        case 'Assembly':
          this.customer.clientType = ClientType.Assembly;
          break;
        default:
          this.customer.clientType = ClientType.NotSelected;
          break;
      }
    }

    private mapFeederType (text: string) {
      switch (text) {
        case 'KV11':
          this.customer.dt.feeder.feederType = FeederType.KV11;
          break;
        case 'KV33':
          this.customer.dt.feeder.feederType = FeederType.KV33;
          break;
        default:
          this.customer.dt.feeder.feederType = FeederType.NOT_SELECTED;
          break;
      }
    }

    private mapBillingType(text: string) {
       switch (text) {
        case 'Prepaid':
          this.customer.billingType = BillingType.Prepaid;
          break;
        case 'Postpaid':
          this.customer.billingType = BillingType.Postpaid;
          break;
        default: 
          this.customer.billingType = BillingType.NotSelected;
          break;
      }
    }

    private mapMeterStatus(text: string) {
      switch(text) {
        case 'Metered':
          this.customer.meter.status = MeterStatus.Metered;
          break;
        case 'Unmetered':
          this.customer.meter.status = MeterStatus.Unmetered;
          break;
        default: 
          this.customer.meter.status = MeterStatus.NotSelected;
          break;
      }
    }

    private mapMeterCondition(text: string) {
      switch(text) {
        case 'Working': 
          this.customer.meter.condition = MeterCondition.Working;
          break;
        case 'NotWorking': 
          this.customer.meter.condition = MeterCondition.NotWorking;
          break;
        case 'Burnt': 
          this.customer.meter.condition = MeterCondition.Burnt;
          break;
        default:
          this.customer.meter.condition = MeterCondition.NotSelected;
          break;
      }
    }
    
    private mapCustomers() {
      this.customer.id = this.customerEdit.id;
      this.customer.buildingOwner = this.customerEdit.buildingOwner;
      this.customer.dataQualityId = this.customerEdit.dataQualityId;
      this.customer.slrn = this.customerEdit.slrn;
      this.customer.name = this.customerEdit.tenantName!;
      this.customer.accountNumber = this.customerEdit.accountNumber;
      this.customer.address = this.customerEdit.address;
      this.customer.email = this.customerEdit.email;
      this.customer.phoneNumber = this.customerEdit.phoneNumber;
      this.customer.tariffName = this.customerEdit.tariffName;
      this.mapServiceType(this.customerEdit.serviceType.toString());
      this.mapBuildingType(this.customerEdit.buildingType.toString());
      this.mapCustomerType(this.customerEdit.customerType.toString());
      this.mapTypeOfConnection(this.customerEdit.typeOfConnection.toString());
      this.mapClientType(this.customerEdit.clientType.toString());
      this.customer.regionId = this.customerEdit.area.regionId;
      this.selectRegion();
      setTimeout(() => {      
        this.customer.areaId = this.customerEdit.area.id;
        this.onAreaChange();
      }, 500);      
      const selectedTariff = this.tariffs.find(t => t.name === this.customerEdit.tariffClass);
      this.customer.tariffId = selectedTariff!.id;
      this.mapFeederType(this.customerEdit.dt.feeder.feederType.toString());
      this.selectFeederVoltage(this.customer.dt.feeder.feederType);
      this.customer.dt.feeder.id = this.customerEdit.dt.feeder.id;
      this.customer.dt.feeder.number = this.customerEdit.dt.feeder.number;
      this.selectedFeederNumber = this.customerEdit.dt.feeder.number;
      setTimeout(() => {      
        this.selectFeeder();
      }, 500);
      this.customer.dtId = this.customerEdit.dtId;
      this.customer.dt.number = this.customerEdit.dt.number;
      this.selectedDtNumber = this.customer.dt.number;
      this.customer.isNew = this.customerEdit.isNew;
      // this.mapBillingType(this.customerEdit.bill);
      this.mapMeterStatus(this.customerEdit.meterStatus.toString());
      this.selectMeterStatus(this.customer.meter.status);
      this.customer.meter.typeId = this.customerEdit.meter.typeId;
      this.onMeterTypeChange(this.customer.meter.typeId);
      this.mapMeterCondition(this.customerEdit.meter.condition.toString());
      this.customer.meter.number = this.customerEdit.meterNo!;
      this.selectedSltStatusKey = this.customerEdit.sltStatus.id;
      this.onSltStatusChange();
    }

  selectFeeder() {
    const selectedFeeder = this.feeders.find(feeder => feeder.id === this.customer.dt.feeder.id);
    this.selectedFeederNumber = selectedFeeder ? selectedFeeder.number || '' : '';
    this.customer.dt.feeder.feederType = selectedFeeder?.feederType ?? FeederType.KV11;
    this.customer.dt.feeder.name = selectedFeeder?.name || '';
    this.customer.dt.feeder.id = selectedFeeder?.id || 0;
    this.customer.dt.feeder.number = this.selectedFeederNumber;
    this.getDts();
  }

  getSltStatuses() {
    this.customerService.getSltStatusesForOptions().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.sltOptions = responseData.data;
        } else if (response?.status == 204) {
          this.toastr.warning('No SLT statuses available');
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while fetching SLT statuses');
      },
    });
  }

  getMeterTypes() {
    this.meterService.getAllMeterTypesForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.meterTypes = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while fetching meter types');
      },
    });
  }

  onSltStatusChange() {
    const selectedOption = this.sltOptions.find(o => o.key == this.selectedSltStatusKey);
    if (selectedOption) {
      this.customer.sltStatus = new SltStatus();
      this.customer.sltStatus.id = selectedOption.key;
      this.customer.sltStatus.value = selectedOption.value;
      this.customer.sltStatus.utilityId = this.utilityId;
    }
  }

  selectMeterStatus(status: MeterStatus) {
    if (status === MeterStatus.Unmetered) {
      this.customer.meter = getInitMeter();
      this.customer.meter.status = MeterStatus.Unmetered;
    } else if (status === MeterStatus.Metered) {
      this.customer.meter = getInitMeter();
      this.customer.meter.status = MeterStatus.Metered;
      this.customer.meter.typeId = 0;
      this.customer.meter.condition = 0;
    }
  }

  backClicked() {
    this.router.navigate(['settings/crud', 12]);
  }

  getDts() {
    this.dtService
      .getAllByFeeder(
        this.customer.dt.feeder.id,
        (this.selectedFeederType !== null ? this.selectedFeederType.toString() : ''),
        this.utilityId
      )
      .subscribe({
        next: (response) => {
          const responseData = response.body;
          if (responseData?.status === 200 || responseData?.status === 'OK' || response.status == 204) {
            this.dts = responseData.data;
          } else {
            this.toastr.error(responseData?.message);
          }
        },
        error: (_) => this.toastr.error('Error occurred'),
      });
  }

  private getRegions() {
    this.regionService.getAllForSelectNoUser(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.regions = responseData.data;
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  selectRegion() {
    this.selectedRegionId = this.customer.regionId;
    this.customer.areaId = 0;
    this.customer.area = new Area();
    this.customer.area.regionId = this.customer.regionId;
    this.regions = this.regions.map(region => ({
      ...region,
      checked: region.id == this.selectedRegionId
    }));
    this.getAreas();
  }

  private getAreas() {
    this.areaService.getAllForOptions(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.allAreas = responseData.data;
          this.areas = this.allAreas.filter((area) =>
            this.regions.some(
              (region) => region.id == area.regionId && region.checked
            )
          );
        } else if (response?.status == 204) {
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  getFeeders11() {
    this.f11Service.getAllForSelect().subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          const feedersFromResponse = responseData.data;
          this.feeders = feedersFromResponse.map((el: Feeder) => ({
            ...el,
            feederType: FeederType.KV11,
          }));
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }
  
  getFeeders33() {
    this.f33Service.getAllForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          if (Array.isArray(responseData.data)) {
            const feedersFromResponse = responseData.data;
            this.feeders = feedersFromResponse.map((el: Feeder) => ({
              ...el,
              feederType: FeederType.KV33,
            }));
          } else {
            this.toastr.error('Invalid response: Expected an array of feeders');
          }
        } else {
          this.toastr.error(responseData?.message || 'Invalid response');
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  getTariffs() {
    this.tariffService.getAllForSelect(this.utilityId).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.tariffs = responseData.data;
        } else {
          this.toastr.error(responseData?.message);
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred');
      },
    });
  }

  selectFeederVoltage(feederVoltage: number) {
    this.selectedFeederType = feederVoltage;
    this.customer.dt.feeder.id = 0;
    this.selectedFeederNumber = '';
    this.feeders = [];
    if (feederVoltage == FeederType.KV11) {
      this.getFeeders11();
    } else if (feederVoltage == FeederType.KV33) {
      this.getFeeders33();
    }
  }

  onAreaChange() {
    const selectedArea = this.areas.find(area => area.id === this.customer.areaId);
    this.customer.area = selectedArea!;
    this.customer.areaId = selectedArea!.id;
  }

  onMeterTypeChange(typeId: number) {
    const selectedMeterType = this.meterTypes.find(meterType => meterType.id === typeId);
    if(this.customer.meter.meterType == null) {
      this.customer.meter.meterType = new MeterType();
    }
    if (selectedMeterType) {
      this.customer.meter.meterType = selectedMeterType;
      this.customer.meter.meterType.utilityId = this.utilityId;
      this.customer.meter.typeId = typeId;
    } else {
      this.customer.meter.typeId = 0;
    }
  }

  onMeterConditionChange(condition: number) {
    this.customer.meter.condition = condition;
  }

  validateCustomerData(): boolean {
    if(!this.customer.tariffId) {
      this.toastr.warning('Tariff is a mandatory field');
      return false;
    }
    if(!this.customer.dtId) {
      this.toastr.warning('DT is a mandatory field');
      return false;
    }
    if(!this.validationService.validateValue(this.customer.accountNumber ?? '', 'AccountNumber')) {
      this.toastr.warning('Invalid Account number');
      return false;
    }
    if(!this.validationService.validateValue(this.customer.meter.number ?? '', 'MeterNumber')) {
      this.toastr.warning('Invalid Meter number');
      return false;
    }
    if(!this.customer.email?.includes('@')) {
      this.toastr.warning('Invalid Email');
      return false;
    }
    return true;
  }

  save() {
    this.customer.area = this.areas.find(area => area.id === this.customer.areaId) || new Area();
    this.customer.tariffName = this.tariffs.find(tariff => tariff.id === this.customer.tariffId)?.name || '';
    this.customer.isNewConnection = true;
    this.customer.utilityId = this.utilityId;
    if (this.selectedSltStatusKey !== null) {
      const selectedOption = this.sltOptions.find(o => o.key == this.selectedSltStatusKey);
      if (selectedOption) {
        this.customer.sltStatus = new SltStatus();
        this.customer.sltStatus.id = selectedOption.key;
        this.customer.sltStatus.value = selectedOption.value;
        this.customer.sltStatus.utilityId = this.utilityId;
      } else {
        this.toastr.error('Invalid SLT status selected');
        return;
      }
    } else {
      this.customer.sltStatus = undefined;
    }

    this.customer.utilityId = this.utilityId;

    if(!this.validateCustomerData()) return;

    this.customerService.addCustomer(this.customer).subscribe({
      next: (response) => {
        const responseData = response.body;
        if (responseData?.status === 200 || responseData?.status === 'OK') {
          this.toastr.success('Customer added successfully');
          setTimeout(() => {
            this.backClicked();
          }, 2000);
        } else {
          this.toastr.error(responseData?.message || 'Failed to add customer');
        }
      },
      error: (_) => {
        this.toastr.error('Error occurred while saving customer');
      },
    });
  }
}